import { styled, Box } from '../../../../base';

export const StyledScrollContainer = styled(Box)(() => ({
    maxHeight: '200px', // Or any other height that fits your design
    overflowY: 'auto',
    paddingInlineEnd: '10px', // To avoid scrollbar overlapping content
    margin: '10px 0',
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: '#f1f1f1',
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
        borderRadius: '10px',
        '&:hover': {
            backgroundColor: '#555',
        },
    },
}));

export const StyledBox = styled('button', {
    shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ theme, isSelected }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    border: `2px solid ${isSelected ? 'orange' : theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    textAlign: 'center',
    width: '120px',
    height: '85px',
    backgroundColor: theme.palette.background.paper,
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    outline: 'none !important',
    WebkitTapHighlightColor: 'transparent',
    '&:hover': {
        borderColor: 'orange',
        boxShadow: theme.shadows[2],
    },
    '&:focus': {
        borderColor: 'orange',
        outline: 'none !important',
    },
    '&:focus-visible': {
        outline: 'none !important',
        borderColor: 'orange',
    },
    '&:active': {},
}));

export const StyledBoxText = styled('div')(({ theme }) => ({
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
    overflow: 'hidden',
    maxHeight: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
}));
